import { render, staticRenderFns } from "./ln-form-review.vue?vue&type=template&id=15b9aa14&"
import script from "./ln-form-review.vue?vue&type=script&lang=js&"
export * from "./ln-form-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports